import React from 'react';
import { Col, Modal, notification, Row, Form, Card } from 'antd';
import FormInput from 'components/FormInput';
import ParListByParcodeSelect from 'pages/Configuration/Components/ParListByParcodeSelect';
import { createParList } from 'services/parametersService';
import GetLabel from 'DisplayFramework/components/GetLabel';

type AddAdresseValueModalProps = {
  onCancel: () => void;
  visible: boolean;
  title: React.ReactNode | string;
  onSuccess?: () => void;
  iscreate?: boolean;
  showAsModal?: boolean;
  refetched: boolean;
  setrefetched: any;
  ParcodeParent: string;
  parcode: string;
  parentname?: string;
  parvalueParent?: string;
};

const AddAdresseValueModal = (props: AddAdresseValueModalProps) => {
  const {
    onCancel,
    visible,
    title,
    ParcodeParent,
    parcode,
    parentname,
    setrefetched,
    parvalueParent,
  } = props;
  const [form] = Form.useForm();
  const submit = () => {
    const currentValue = form.getFieldsValue();
    const body = { ...currentValue, parcode: parcode };
    createParList({ parListRequest: body }).then((response) => {
      if (response.code === '200') {
        notification.success({
          message: `${currentValue.parvalue} is created`,
        });
        onCancel();
      } else {
        notification.error({
          message: response.message,
          description: response.description,
        });
      }
    });
  };

  return (
    <Modal
      visible={visible}
      destroyOnClose
      width={600}
      title={title}
      onOk={submit}
      onCancel={onCancel}
    >
      <Card>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={12}>
              <FormInput name="parvalue" />
            </Col>
            <Col xs={12}>
              <FormInput name="parlistlabel" />
            </Col>
            <Col xs={12}>
              <Form.Item
                label={
                  <div>
                    <GetLabel label="parvalueparent" /> {parentname && ' : '}
                    {parentname && <GetLabel label={parentname} />}
                  </div>
                }
                name="parvalueparent"
                hidden={ParcodeParent.length === 0}
              >
                <ParListByParcodeSelect
                  forcedValue={parvalueParent}
                  parcode={ParcodeParent ?? ''}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default AddAdresseValueModal;
